<div class="seneca-list-container">
  <mat-card class="main-container mat-elevation-z2">
    <mat-card-title>
      <h1 class="card-title">Commission Requests (New)</h1>
    </mat-card-title>

    <mat-card-content>
      <div class="document-instructions">
        <div class="onboarding-list">
          <div class="onboarding-item">
            <div class="instruction-marker" aria-hidden="true"></div>
            <div class="onboarding-content">
              Select the relevant term from the dropdown menu, you may submit claims from Fall 2024 and later
            </div>
          </div>

          <div class="onboarding-item">
            <div class="instruction-marker" aria-hidden="true"></div>
            <div class="onboarding-content">
              To request commission, select student(s) and click Submit My Claims
            </div>
          </div>

          <div class="onboarding-item">
            <div class="instruction-marker" aria-hidden="true"></div>
            <div class="onboarding-content">
              To identify a discrepancy in commission amount, click Dispute. This may be due to the student's late tuition payment.
            </div>
          </div>

          <div class="onboarding-item">
            <div class="instruction-marker" aria-hidden="true"></div>
            <div class="onboarding-content">
              To view additional details about a student, click the row
            </div>
          </div>

          <div class="onboarding-item">
            <div class="instruction-marker" aria-hidden="true"></div>
            <div class="onboarding-content">
              If you are missing a commission,
              <a
                class="instruction-link"
                [class.disabled]="commissionsLocked"
                (click)="!commissionsLocked && onDispute()"
              >click here</a>
              to let us know
            </div>
          </div>
        </div>

        <div class="onboarding-footer-divider"></div>
        <p class="onboarding-footer-text">
          <span class="bold-red-text">Note:</span>
          Commission for students enrolled in the English Language Institute (ELI) will be paid
          in the subsequent term. Fall 2025 ELI commission will be paid in February 2026.
        </p>
      </div>

      <app-claims-table
        (eventClick)="passEmit($event)"
        [commissionsLocked]="commissionsLocked"
        [commissionsLockedMessage]="commissionsLockedMessage"
      ></app-claims-table>
    </mat-card-content>
  </mat-card>
</div>
